import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IconName } from '../../constants/icons.enum';

@Injectable({ providedIn: 'root' })
export class IconService {
  private readonly baseIconUrl = 'assets/icons';
  private readonly icons = Object.values(IconName);

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {}

  public init() {
    const byPass = this.sanitizer.bypassSecurityTrustResourceUrl.bind(this.sanitizer);
    const addIcon = this.iconRegistry.addSvgIcon.bind(this.iconRegistry);

    // Add a cache-busting parameter based on the app version or build time
    const cacheBuster = new Date().getTime();

    // All icons are now loaded from the unified 'assets/icons' folder
    this.icons.forEach((name) => {
      addIcon(name, byPass(`${this.baseIconUrl}/${name}.svg?v=${cacheBuster}`));
    });
  }
}
